export const buildChartData = (
  wheelOfLifeCategories,
  wheelOfLifeCategoryColors,
  wheelOfLifeData = null
) =>
  wheelOfLifeCategories.map((category, index) => ({
    label: category.label,
    value: wheelOfLifeData?.[category.value] ?? 0,
    field: category.value,
    color: wheelOfLifeCategoryColors[index],
  }));
